export default __webpack_public_path__ + "static/10-c9b05badcf9a4aec9b1981ae89e31fb7.jpg";